var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 12.5C3.44501 12.5 0.833333 9.88833 0.833333 6.66667C0.833333 3.44501 3.44501 0.833333 6.66667 0.833333C9.88833 0.833333 12.5 3.44501 12.5 6.66667C12.5 9.88833 9.88833 12.5 6.66667 12.5ZM6.66667 13.3333C10.3486 13.3333 13.3333 10.3486 13.3333 6.66667C13.3333 2.98477 10.3486 0 6.66667 0C2.98477 0 0 2.98477 0 6.66667C0 10.3486 2.98477 13.3333 6.66667 13.3333Z",
    fill: "#1C1C1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44225 5.48991L5.53307 5.72917L5.46471 6.04655L5.84069 6.11491C6.08483 6.1735 6.13366 6.26139 6.07995 6.50553L5.46471 9.39616C5.30358 10.1432 5.5526 10.4948 6.13854 10.4948C6.59264 10.4948 7.11999 10.2848 7.35924 9.99674L7.43249 9.65006C7.26647 9.79655 7.02233 9.85514 6.8612 9.85514C6.63171 9.85514 6.5487 9.69401 6.60729 9.41081L7.44225 5.48991Z",
    fill: "#1C1C1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3.75C7.5 4.21024 7.1269 4.58333 6.66667 4.58333C6.20643 4.58333 5.83333 4.21024 5.83333 3.75C5.83333 3.28976 6.20643 2.91667 6.66667 2.91667C7.1269 2.91667 7.5 3.28976 7.5 3.75Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.f1b69bb87044c1f5588196a44fde47be.svg";
export { ForwardRef as ReactComponent };